import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CaseResponse,TaskResponse,RemindersResponse,NotificationsResponse } from '../models/calender-case.model'; 
import { BaseHttpService } from '@app/lib/services/base-http.service'; 
import { AppConfiguration } from '@app/lib/services/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class CalenderCaseService extends BaseHttpService {
    private baseUrl:string;

  constructor(
    private router: Router, 
    http: HttpClient,
    appConfig: AppConfiguration
    ) {
        super(http, appConfig);
        this.baseUrl = this.appConfig.hostUrl;
    }

  navigateToRoute(route: string, queryParams: any = {}): void {
    this.router.navigate([route], { queryParams });
  }

  fetchCasesByDate(calendarDate: string): Observable<CaseResponse> {
    const url = `${this.baseUrl}calender/cases.htm?calendarDate=${calendarDate}`;
    return this.http.get<CaseResponse>(url);
  }

  fetchTasksByDate(calendarDate: string): Observable<TaskResponse> {
    const url = `${this.baseUrl}/calender/tasks.htm?calendarDate=${calendarDate}`;
    return this.http.get<TaskResponse>(url);
  }

  fetchRemindersByDate(calendarDate: string): Observable<RemindersResponse> {
    const url = `${this.baseUrl}calender/reminders.htm?calendarDate=${calendarDate}`;
    return this.http.get<RemindersResponse>(url);
  }

  fetchNotificationsByDate(calendarDate: string): Observable<NotificationsResponse> {
    const url = `${this.baseUrl}calender/notifications.htm?calendarDate=${calendarDate}`;
    return this.http.get<NotificationsResponse>(url);
  }

}
